import LinkType, { LinkSizes, LinkTypes } from './LinkType';

const possibleLinkSizeClassNames: Record<LinkSizes, string> = {
    large: 'large-link button--size-large',
    small: 'button--size-small',
    standard: 'button--size-standard',
};

const possibleLinkClassNames: Record<LinkTypes, { core: string; size?: Record<LinkSizes, string> }> = {
    'button-positive': { core: 'button--positive', size: possibleLinkSizeClassNames },
    'button-negative': { core: 'button--negative', size: possibleLinkSizeClassNames },
    icon: { core: 'icon sgw-button button--icon' },
    inline: { core: 'inline' },
    link: { core: 'link button--link', size: possibleLinkSizeClassNames },
    return: { core: 'return sgw-link__return-link' },
};

export const mapClassNames = (type: LinkTypes, size: LinkSizes): string => {
    const classNames = possibleLinkClassNames[type] ?? possibleLinkClassNames.link;
    return `${classNames.core}${classNames.size ? ` ${classNames.size[size]}` : ''}`;
};

const iconOnlyArray: LinkTypes[] = ['icon', 'return'];
const linkOnlyArray: LinkTypes[] = ['link', 'button-negative', 'button-positive'];

export const isIconOnly = (type: LinkTypes) => iconOnlyArray.includes(type);
export const isStandardLink = (type: LinkTypes) => linkOnlyArray.includes(type);

export const mapLinkTypes = (type: LinkType | LinkTypes, size: LinkSizes): { type: LinkTypes; size: LinkSizes } => {
    switch (type) {
        case LinkType.LARGE_LINK:
            return { type: 'link', size: 'large' };

        case LinkType.ICON:
            return { type: 'icon', size };

        case LinkType.BUTTON_SMALL_POSITIVE:
            return { type: 'button-positive', size: 'small' };
        case LinkType.BUTTON_SMALL_NEGATIVE:
            return { type: 'button-negative', size: 'small' };

        case LinkType.BUTTON_STANDARD_POSITIVE:
            return { type: 'button-positive', size };
        case LinkType.BUTTON_STANDARD_NEGATIVE:
            return { type: 'button-negative', size };

        case LinkType.BUTTON_LARGE_POSITIVE:
            return { type: 'button-positive', size: 'large' };
        case LinkType.BUTTON_LARGE_NEGATIVE:
            return { type: 'button-negative', size: 'large' };

        case 'inline':
        case LinkType.INLINE:
            return { type: 'inline', size: 'standard' };

        case 'return':
        case LinkType.RETURN:
            return { type: 'return', size: 'standard' };

        default:
            return { type, size };
    }
};
